import { Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';

export interface IDonorNoteRow {
  id: string;
  createdAt: string;
  author: string;
  isPinned: boolean;
  text: string;
  fileCount: number;
}

export const noteColumns: ColumnsType<IDonorNoteRow> = [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 110,
    render: (date: string) => dayjs(date).format('MM/DD/YYYY'),
    sorter: (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    defaultSortOrder: 'descend' as const,
  },
  {
    title: 'Author',
    dataIndex: 'author',
    key: 'author',
    width: 130,
    sorter: (a, b) => a.author.localeCompare(b.author),
  },
  {
    title: 'Pinned',
    dataIndex: 'isPinned',
    key: 'isPinned',
    width: 70,
    render: (pinned: boolean) =>
      pinned ? <Tag color="gold">Pinned</Tag> : null,
    filters: [
      { text: 'Pinned', value: true },
      { text: 'Not Pinned', value: false },
    ],
    onFilter: (value, record) => record.isPinned === value,
  },
  {
    title: 'Note',
    dataIndex: 'text',
    key: 'text',
    render: (text: string) => (
      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {text}
      </div>
    ),
  },
  {
    title: 'Files',
    dataIndex: 'fileCount',
    key: 'fileCount',
    width: 60,
    render: (count: number) => (count > 0 ? count : null),
  },
];
